var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef, } from 'react';
import { useRegisterFocus } from '../FocusZone';
export const ButtonBase = forwardRef((_a, forwardedRef) => {
    var { children, type = 'button' } = _a, props = __rest(_a, ["children", "type"]);
    const ref = useRef(null);
    useImperativeHandle(forwardedRef, () => ref.current);
    useRegisterFocus(ref);
    return (_jsx("button", Object.assign({}, props, { ref: ref, type: type }, { children: children }), void 0));
});
ButtonBase.displayName = 'ButtonBase';
//# sourceMappingURL=ButtonBase.js.map